import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, X, Package } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function RecentlyViewedNudge() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [p, setP] = useState(null);

  useEffect(() => {
    if (user?.role !== "customer") return;
    api.get("/marketplace/recommendations/recently-viewed-nudge").then((r) => {
      const prod = r.data?.product;
      if (!prod) return;
      if (sessionStorage.getItem(`rv-nudge-dismissed:${prod.product_id}`)) return;
      setP(prod);
    }).catch(() => {});
  }, [user?.role]);

  if (!p) return null;
  const img = p.thumb || (p.images || [])[0] || p.image;
  const dismiss = () => { sessionStorage.setItem(`rv-nudge-dismissed:${p.product_id}`, "1"); setP(null); };

  return (
    <div className="fixed bottom-4 left-4 z-40 w-72 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-xl animate-in fade-in slide-in-from-bottom-4" data-testid="recently-viewed-nudge">
      <div className="flex items-center justify-between border-b border-slate-100 px-3 py-2">
        <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-blue-600"><Eye className="h-3.5 w-3.5" /> Still thinking about this?</span>
        <button onClick={dismiss} data-testid="rv-nudge-dismiss" className="text-slate-400 hover:text-slate-700"><X className="h-4 w-4" /></button>
      </div>
      <button onClick={() => { dismiss(); nav(`/product/${p.slug || p.product_id}`); }} data-testid="rv-nudge-product" className="flex w-full items-center gap-3 p-3 text-left hover:bg-slate-50">
        <span className="flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-slate-100">
          {img ? <img src={img} alt="" className="h-full w-full object-cover" /> : <Package className="h-5 w-5 text-slate-300" />}
        </span>
        <span className="min-w-0">
          <span className="line-clamp-2 text-sm font-medium text-slate-800">{p.name}</span>
          <span className="mt-0.5 block text-sm font-bold text-slate-900">₹{Math.round(p.price || 0)}</span>
        </span>
      </button>
    </div>
  );
}
